export default __webpack_public_path__ + "static/media/choco-box@3x.bac87ea6.png";